import { Gender } from '@app/graphql/types'

export enum Salutation {
  M = 'Herr',
  F = 'Frau',
  D = 'Divers'
}

export function getSalutation(gender) {
  switch (gender) {
    case Gender.M:
      return Salutation.M
    case Gender.F:
      return Salutation.F
    default:
      return Salutation.D
  }
}
